import React from 'react';
import { PANEL, SectionHead } from './parts';

const STATUS = {
  critical: { label: 'Critical', className: 'bg-[rgba(255,107,107,0.15)] text-[#FF6B6B]' },
  fix: { label: 'Fix', className: 'bg-[rgba(245,185,66,0.15)] text-amber' },
  pass: { label: 'Pass', className: 'bg-[rgba(61,214,140,0.13)] text-[#3DD68C]' },
  na: { label: 'N/A', className: 'bg-[rgba(154,167,187,0.1)] text-dim' },
};

// Plain, evidence-only checks (HTTPS, alt text, privacy, SMS consent, PCI).
// `children` sits in the right-hand column beside the sheet, as in the preview.
export default function ComplianceSheet({ rows = [], children = null }) {
  return (
    <>
      <SectionHead title="Compliance sheet" note="Plain checks, not legal advice. Ranges are typical and marked for review." />
      <div className="grid grid-cols-1 gap-4 lg:grid-cols-[minmax(0,1.25fr)_minmax(0,0.75fr)]">
        <div className={PANEL}>
          <table className="w-full border-collapse text-sm">
            <caption className="sr-only">Compliance checks</caption>
            <tbody>
              {rows.map((row, index) => {
                const status = STATUS[row.status] || STATUS.na;
                return (
                  <tr key={row.key || index} className={index < rows.length - 1 ? 'border-b border-white/10' : ''}>
                    <td className="w-[88px] py-3 pr-3 align-top">
                      <span className={`inline-block rounded-md px-2 py-[3px] text-[11px] font-semibold uppercase tracking-[0.05em] ${status.className}`}>{status.label}</span>
                    </td>
                    <td className="py-3 align-top">
                      <div className="font-semibold">{row.rule}</div>
                      <div className="mt-0.5 text-[13px] text-mist">{row.why}</div>
                      {row.exposure ? <div className="mt-1 font-mono text-[11.5px] text-amber">{row.exposure}</div> : null}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
        {children ? <div>{children}</div> : null}
      </div>
    </>
  );
}
